import React, { useState, useEffect, useContext } from "react";
import axios from "axios";
import NumberFormat from "react-number-format";
import CircularProgress from "@material-ui/core/CircularProgress";
import moment from "moment";
import Button from "@material-ui/core/Button";

// import { UserContext } from "../../UserContext";
import { UserContext } from "../../../UserContext";
import MosaicLogo from "../../../assets/images/mosaic-logo.svg";
import ssl from "../../../assets/images/ssl.svg";
import encryption from "../../../assets/images/encryption.svg";
import ehl1 from "../../../assets/images/ehl-1.svg";
import checkmark from "../../../assets/images/checkmark.svg";

// This is where you apply for a mosaic loan & submit the application...

// require('dotenv').config()

const MosaicQualify = ({
  disclosures,
  agreed,
  repEmail,
  setAgreed,
  bundleId,
  name,
  projectID,
  email,
  phone,
  street,
  city,
  state,
  zip,
  setQualify,
  viewApps,
  setViewApps,
  financingAmount,
  mod,
  invType,
  invModel,
}) => {
  const { activeUser, setActiveUser } = useContext(UserContext);

  // console.log(activeUser.username)

  let names = name.split(" ");

  const [firstName, setFirstName] = useState("");
  const [lastName, setLastName] = useState("");
  const [middleName, setMiddleName] = useState("string");
  const [emailA, setEmailA] = useState("");
  const [phoneNumber, setPhoneNumber] = useState("");
  const [streetA, setStreetA] = useState("");
  const [cityA, setCityA] = useState("");
  const [stateA, setStateA] = useState("");
  const [zipA, setZipA] = useState("");
  const [annualIncome, setAnnualIncome] = useState("");
  const [secondaryIncome, setSecondaryIncome] = useState("");
  const [social, setSocial] = useState("");
  const [birthMonth, setBirthMonth] = useState("");
  const [birthDay, setBirthDay] = useState("");
  const [birthYear, setBirthYear] = useState("");
  const [coFirstName, setCoFirstName] = useState("");
  const [coLastName, setCoLastName] = useState("");
  const [coMiddleName, setCoMiddleName] = useState("string");
  const [coEmailA, setCoEmailA] = useState("");
  const [coPhoneNumber, setCoPhoneNumber] = useState("");
  const [coStreetA, setCoStreetA] = useState("");
  const [coCityA, setCoCityA] = useState("");
  const [coStateA, setCoStateA] = useState("");
  const [coZipA, setCoZipA] = useState("");
  const [coAddress, setCoAddress] = useState(false);
  const [coAnnualIncome, setCoAnnualIncome] = useState("");
  const [coSocial, setCoSocial] = useState("");
  const [coBirthMonth, setCoBirthMonth] = useState("");
  const [coBirthDay, setCoBirthDay] = useState("");
  const [coBirthYear, setCoBirthYear] = useState("");
  const [bunId, setBunId] = useState("");
  const [confirmedApp, setConfirmedApp] = useState(false);
  const [ownHome, setOwnHome] = useState(false);
  const [coOwnHome, setCoOwnHome] = useState(false);
  const [applicationId, setApplicationId] = useState("");
  const [creditResult, setCreditResult] = useState("Pending");
  const [creditMessage, setCreditMessage] = useState({});
  const [ecoa, setEcoa] = useState("");
  const [coApp, setCoApp] = useState("");
  const [cpa2, setCpa2] = useState("");
  const [viewCpa2, setViewCpa2] = useState(false);
  const [ehl, setEhl] = useState("");
  const [arb, setArb] = useState("");
  const [res, setRes] = useState("");
  const [resVersion, setResVersion] = useState("");
  const [resident, setResident] = useState("");
  const [coResident, setCoResident] = useState("");
  const [viewArb, setViewArb] = useState(false);
  const [esign, setEsign] = useState("");
  const [viewEsign, setViewEsign] = useState(false);
  const [income, setIncome] = useState("");
  const [viewIncome, setViewIncome] = useState(false);
  const [otherInc, setOtherInc] = useState("");
  const [own, setOwn] = useState("");
  const [ownVersion, setOwnVersion] = useState("");
  const [pad, setPad] = useState("");
  const [stateDisc, setStateDisc] = useState("");
  const [viewStateDisc, setViewStateDisc] = useState(false);
  const [gd, setGd] = useState("");
  const [viewGd, setViewGd] = useState(false);
  const [tcpa, setTcpa] = useState("");
  const [viewTcpa, setViewTcpa] = useState(false);
  const [mpp, setMpp] = useState("");
  const [trueLender, setTrueLender] = useState("");
  const [loading, setLoading] = useState(false);
  const [signLoading, setSignLoading] = useState(false);
  const [apps, setApps] = useState([]);
  const [approvedLoans, setApprovedLoans] = useState([]);
  const [financeProductId, setFinanceProductId] = useState("");
  const [offerId, setOfferId] = useState("");
  const [shareId, setShareId] = useState("");
  const [showError, setShowError] = useState(false);
  const [errorMessage, setErrorMessage] = useState("");
  const [offerLink, setOfferLink] = useState("");
  const [confirmEmail, setConfirmEmail] = useState(false);
  const [mosaicProjId, setMosaicProjId] = useState("");
  const [mosaicOfferId, setMosaicOfferId] = useState("");
  const [coApply, setCoApply] = useState(false);
  const [agree, setAgree] = useState(false);

  const listOfStates = require("us-state-converter");

  // console.log(listOfStates)

  const fiftyStates = listOfStates.only50();

  //production url for mosaic
  const apiUrl =
    "https://dev.iondeveloper.com/api/proposal/Mosaic/mosaicProposal.php";
  //development url for mosaic
  // const apiUrl = 'https://dev.iondeveloper.com/api/proposal/Mosaic/mosaicProposalTest.php'

  const creditLoad = () => {
    setTimeout(function () {
      setLoading(false);
      // mosaicApiGetApp('getApp', applicationId)
    }, 7000);
  };

  useEffect(() => {
    setFirstName(names[0]);
    setLastName(names[1]);
    setEmailA(email);
    setPhoneNumber(phone);
    setStreetA(street);
    setCityA(city);
    setStateA(listOfStates.abbr(state));
    setZipA(zip);
  }, [name, email, phone, street, city, state, zip]);

  useEffect(() => {
    setBunId(bundleId);
  }, [bundleId]);

  let abbrState = listOfStates.abbr(stateA);

  let fullBirthDate = moment(`${birthYear}-${birthMonth}-${birthDay}`).format(
    "YYYY-MM-DD"
  );
  let coFullBirthDate = moment(
    `${coBirthYear}-${coBirthMonth}-${coBirthDay}`
  ).format("YYYY-MM-DD");

  useEffect(() => {
    if (birthDay.length === 1) {
      setBirthDay("0" + birthDay);
    }
  }, [birthDay]);

  useEffect(() => {
    if (coBirthDay.length === 1) {
      setCoBirthDay("0" + coBirthDay);
    }
  }, [coBirthDay]);

  let primaryOwn = [];
  let coOwn = [];

  if (resident) {
    primaryOwn = [
      {
        assetCode: "RES",
        version: resVersion,
      },
    ];
  }
  if (ownHome) {
    primaryOwn = [
      {
        assetCode: "OWN",
        version: ownVersion,
      },
    ];
  }
  if (ownHome && resident) {
    primaryOwn = [
      {
        assetCode: "OWN",
        version: ownVersion,
      },
      {
        assetCode: "RES",
        version: resVersion,
      },
    ];
  }
  if (coResident) {
    coOwn = [
      {
        assetCode: "RES",
        version: resVersion,
      },
    ];
  }
  if (coOwnHome) {
    coOwn = [
      {
        assetCode: "OWN",
        version: ownVersion,
      },
    ];
  }
  if (coOwnHome && coResident) {
    coOwn = [
      {
        assetCode: "OWN",
        version: ownVersion,
      },
      {
        assetCode: "RES",
        version: resVersion,
      },
    ];
  }

  let applicant = {
    applicants: [
      {
        language: "en",
        firstName: firstName,
        middleName: middleName,
        lastName: lastName,
        emailAddress: emailA,
        addresses: [
          {
            street: streetA,
            city: cityA,
            stateAbbreviation: stateA,
            zipCode: zipA,
            residenceType: "Primary",
            addressTags: ["Billing"],
          },
        ],
        phoneNumber: `+1${phoneNumber.replace(/\D/g, "")}`,
        dateOfBirth: fullBirthDate,
        socialSecurityNumber: social.replace(/\D/g, ""),
        annualIncome: annualIncome.replace(/\D/g, ""),
        otherHouseholdIncome: secondaryIncome.replace(/\D/g, ""),
        applicantType: "Primary",
      },
    ],
    disclosuresBundleId: bunId,
    // "salesRepIdentifier": 'qa+unassigned+ionsolar@joinmosaic.com',
    salesRepIdentifier: activeUser.username,
    externalId: "string",
  };

  let coApplicants = {
    primaryApplicant: {
      firstName: firstName,
      middleName: middleName,
      lastName: lastName,
      emailAddress: emailA,
      primaryAddress: {
        street: streetA,
        city: cityA,
        stateAbbreviation: stateA,
        zipCode: zipA,
      },
      phoneNumber: `+1${phoneNumber.replace(/\D/g, "")}`,
      dateOfBirth: fullBirthDate,
      socialSecurityNumber: social.replace(/\D/g, ""),
      annualIncome: annualIncome.replace(/\D/g, ""),
      disclosuresAccepted: primaryOwn,
    },
    secondaryApplicant: {
      firstName: coFirstName,
      middleName: coMiddleName,
      lastName: coLastName,
      emailAddress: coEmailA,
      primaryAddress: {
        street: coStreetA || streetA,
        city: coCityA || cityA,
        stateAbbreviation: coStateA || stateA,
        zipCode: coZipA || zipA,
      },
      phoneNumber: `+1${coPhoneNumber.replace(/\D/g, "")}`,
      dateOfBirth: coFullBirthDate,
      socialSecurityNumber: coSocial.replace(/\D/g, ""),
      annualIncome: coAnnualIncome.replace(/\D/g, ""),
      disclosuresAccepted: coOwn,
    },
    otherHouseholdIncome: 0,
    projectAddress: {
      street: streetA,
      city: cityA,
      stateAbbreviation: stateA,
      zipCode: zipA,
    },
    mailingAddress: {
      street: streetA,
      city: cityA,
      stateAbbreviation: stateA,
      zipCode: zipA,
    },
    language: "en",
    disclosuresBundleId: bunId,
    // "salesRepIdentifier": 'qa+unassigned+ionsolar@joinmosaic.com',
    salesRepIdentifier: activeUser.username,
    externalId: "string",
  };

  if (secondaryIncome.toString().length < 1) {
    setSecondaryIncome("0");
  }

  let application = applicant;

  if (coApply) {
    application = coApplicants;
  }

  let offer = {
    financingProductId: financeProductId,
    projects: [
      {
        amount: financingAmount,
        projectType: "Solar",
      },
    ],
  };

  let equipmentInfo = {
    equipmentType: "Solar",
    panel: {
      manufacturer: mod[1],
      model: mod[2],
      inverter: {
        manufacturer: invType,
        model: invModel,
      },
    },
    totalSystemPrice: financingAmount,
  };

  let offerType = {
    method: "Link",
  };

  const daysInMonth = new Date(+birthYear, birthMonth, 0).getDate();
  const coDaysInMonth = new Date(+coBirthYear, coBirthMonth, 0).getDate();

  const days = [];
  const coDays = [];
  const years = [];

  const findDays = (arr, num) => {
    for (var i = 1; i < num + 1; i++) {
      arr.push(i);
    }
  };

  const findYears = (arr) => {
    for (var i = 1930; i < new Date().getFullYear() - 17; i++) {
      arr.push(i);
    }
  };

  findDays(days, daysInMonth);
  findDays(coDays, coDaysInMonth);
  findYears(years);

  useEffect(() => {
    if (disclosures.length > 0) {
      disclosures.forEach((obj, i) => {
        if (obj.assetCode === "COAPP") {
          setCoApp(obj.contents[0].data);
        }
        if (obj.assetCode === "ECOA") {
          setEcoa(obj.contents[0].data);
        }
        if (obj.assetCode === "CPA_2") {
          setCpa2(obj.contents[0].data);
        }
        if (obj.assetCode === "EHL") {
          setEhl(obj.contents[0].data);
        }
        if (obj.assetCode === "ARB") {
          setArb(obj.contents[0].data);
        }
        if (obj.assetCode === "ESIGN_1") {
          setEsign(obj.contents[0].data);
        }
        if (obj.assetCode === "INCOME") {
          setIncome(obj.contents[0].data);
        }
        if (obj.assetCode === "OTHERINC") {
          setOtherInc(obj.contents[0].data);
        }
        if (obj.assetCode === "OWN") {
          setOwn(obj.contents[0].data);
          setOwnVersion(obj.version);
        }
        if (obj.assetCode === "RES") {
          setRes(obj.contents[0].data);
          setResVersion(obj.version);
        }
        if (obj.assetCode === "PAD") {
          setPad(obj.contents[0].data);
        }
        if (obj.assetCode === "STATE") {
          setStateDisc(obj.contents[0].data);
        }
        if (obj.assetCode === "GD") {
          setGd(obj.contents[0].data);
        }
        if (obj.assetCode === "TCPA_1") {
          setTcpa(obj.contents[0].data);
        }
        if (obj.assetCode === "MPP") {
          setMpp(obj.contents[0].data);
        }
        if (obj.assetCode === "TRUELENDER") {
          setTrueLender(obj.contents[0].data);
        }
      });
    }
  }, [disclosures]);

  let states = [
    { state: "California" },
    { state: "Colorado" },
    { state: "Florida" },
    { state: "Idaho" },
    { state: "Nevada" },
    { state: "New Jersey" },
    { state: "New Mexico" },
    { state: "North Carolina" },
    { state: "Oregon" },
    { state: "South Carolina" },
    { state: "Texas" },
    { state: "Utah" },
    { state: "Virginia" },
    { state: "Wyoming" },
  ];

  let mappedStates = fiftyStates.map((state, i) => {
    return (
      <option key={i} value={state.usps}>
        {state.usps}
      </option>
    );
  });

  let months = [
    { month: "January", val: "01" },
    { month: "February", val: "02" },
    { month: "March", val: "03" },
    { month: "April", val: "04" },
    { month: "May", val: "05" },
    { month: "June", val: "06" },
    { month: "July", val: "07" },
    { month: "August", val: "08" },
    { month: "September", val: "09" },
    { month: "October", val: "10" },
    { month: "November", val: "11" },
    { month: "December", val: "12" },
  ];

  let mappedMonths = months.map((month, i) => {
    return (
      <option key={i} value={month.val}>
        {month.month}
      </option>
    );
  });

  const mappedDays = days.map((num, i) => {
    return (
      <option key={i} value={num}>
        {num}
      </option>
    );
  });

  const mappedCoDays = coDays.map((num, i) => {
    return (
      <option key={i} value={num}>
        {num}
      </option>
    );
  });

  const mappedYears = years.reverse().map((num, i) => {
    return (
      <option key={i} value={num}>
        {num}
      </option>
    );
  });

  // let mappedApprovedLoans = approvedLoans.map((loan, i) => {
  //   return (
  //     <option key={i} value={loan.id}>{loan.name === 'Ion PowerSwitch Choice 9.0 25.499.30.1' ? '25 yr 4.99%' : loan.name === 'Ion PowerSwitch Choice 9.0 15.459.30.1' ? '15 yr 4.59%' : loan.name === 'PowerSwitch Choice 2.0 25.199.B.26' ? '25 yr 1.99%' : loan.name} APR</option>
  //   )
  // })

  // let approvedLoans = [/* Your array of approved loans here */];

  const loanNameToDisplay = {
    "Ion PowerSwitch Choice 9.0 25.499.30.1": "25 yr 4.99%",
    "Ion PowerSwitch Choice 9.0 25.499.30.3": "25 yr 4.99%",
    "Ion PowerSwitch Choice 9.0 15.459.30.1": "15 yr 4.59%",
    "Ion PowerSwitch Choice 9.0 15.459.30.2": "15 yr 4.59%",
    "PowerSwitch Choice 2.0 25.199.B.26": "25 yr 1.99%",
  };

  let filteredApprovedLoans = approvedLoans.filter((loan) =>
    loanNameToDisplay.hasOwnProperty(loan.name)
  );

  let mappedApprovedLoans = filteredApprovedLoans.map((loan, i) => (
    <option key={i} value={loan.id}>
      {loanNameToDisplay[loan.name]} APR
    </option>
  ));

  const addMosaicApp = (appId) => {
    axios
      .post(
        `https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`,
        {
          method: "add_mosaic_app_new",
          project_id: projectID,
          application_id: appId,
          first_name: firstName,
          last_name: lastName,
          email: emailA,
          phone_number: phoneNumber.replace(/\D/g, ""),
          co_first_name: coFirstName,
          co_last_name: coLastName,
          co_email: coEmailA,
          co_phone_number: coPhoneNumber,
        }
      )
      .then((res, err) => {
        if (err) {
          console.log(err);
        }
        // console.log(res)
      });
  };

  const getMosaicApp = () => {
    axios
      .post(
        `https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`,
        { method: "get_mosaic_app_new", project_id: projectID }
      )
      .then((res, err) => {
        if (err) {
          console.log(err);
        }
        // console.log(res.data)
        if (res.data.data.length > 0) {
          // setApplicationId(res.data.data.appId)
          // mosaicApiGetApp('getApp', res.data.data.appId)
          setApps(res.data.data);
        }
      });
  };

  const addMosaicDecision = (appId, decision) => {
    axios
      .post(
        `https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`,
        {
          method: "add_mosaic_decision",
          application_id: appId,
          decision: decision,
        }
      )
      .then((res, err) => {
        if (err) {
          console.log(err);
        }
        // console.log(res.data)
      });
  };

  const addMosaicOfferId = (appId, offerId) => {
    axios
      .post(
        `https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`,
        {
          method: "add_mosaic_offer_id",
          application_id: appId,
          offer_id: offerId,
        }
      )
      .then((res, err) => {
        if (err) {
          console.log(err);
        }
        // console.log(res.data)
      });
  };

  const addMosaicShareId = (appId, shareId) => {
    axios
      .post(
        `https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`,
        {
          method: "add_mosaic_share_id",
          application_id: appId,
          share_id: shareId,
        }
      )
      .then((res, err) => {
        if (err) {
          console.log(err);
        }
        // console.log(res.data)
      });
  };

  const mosaicApiGetApp = (method, appId) => {
    axios
      .post(apiUrl, {
        method: method,
        appId: appId,
      })
      .then((res, err) => {
        if (err) {
          console.log(err);
        }
        // console.log(res.data)
        if (res.data.decision.result) {
          setCreditMessage(res.data.decision);
          setCreditResult(res.data.decision.result);
          addMosaicDecision(appId, res.data.decision.status);
        }
        if (
          res.data.decision.status === "Approved" ||
          res.data.decision.status === "ApprovedWithStipulations"
        ) {
          setApprovedLoans(res.data.decision.financingProducts);
        }
      });
  };
  const mosaicApiGetAppFromList = (method, appId) => {
    axios
      .post(apiUrl, {
        method: method,
        appId: appId,
      })
      .then((res, err) => {
        if (err) {
          console.log(err);
        }
        // console.log(res.data)
        if (res.data.decision.result) {
          setCreditMessage(res.data.decision);
          setCreditResult(res.data.decision.result);
        }
        if (
          res.data.decision.status === "Approved" ||
          res.data.decision.status === "ApprovedWithStipulations"
        ) {
          setApprovedLoans(res.data.decision.financingProducts);
        }
      });
  };

  const getMosaicAppInfo = (appId) => {
    axios
      .post(
        `https://dev.iondeveloper.com/api/proposal/proposal-tool/?api_key=${process.env.REACT_APP_API_KEY}`,
        { method: "get_mosaic_app_info", application_id: appId }
      )
      .then((res, err) => {
        if (err) {
          console.log(err);
        }
        // console.log(res.data)
        if (res.data.data) {
          mosaicApiGetAppFromList("getApp", appId);
          setFirstName(res.data.data.appFirstName);
          setLastName(res.data.data.appLastName);
          setEmailA(res.data.data.appEmail);
          setPhoneNumber(res.data.data.appPhone);
          setCoFirstName(res.data.data.appCoFirstName);
          setCoLastName(res.data.data.appCoLastName);
          setCoEmailA(res.data.data.appCoEmail);
          setCoPhoneNumber(res.data.data.appCoPhone);
          setApplicationId(appId);
          setOfferId(res.data.data.offerId);
          setShareId(res.data.data.shareId);
        }
      });
  };

  let version = "v2";

  if (coApply) {
    version = "v3";
  }

  const mosaicApi = (method, version, applicant) => {
    axios
      .post(apiUrl, {
        method: method,
        version: version,
        applicant: JSON.stringify(applicant),
      })
      .then((res, err) => {
        if (err) {
          console.log(err);
        }
        console.log(res.data.errors);
        if (res.data.errors) {
          return (
            setShowError(true),
            setErrorMessage(`${res.data.errors[0].message}`),
            setTimeout(function () {
              setShowError(false);
              setErrorMessage(``);
            }, 10000),
            setLoading(false)
          );
        }
        if (res.data.application.id) {
          addMosaicApp(res.data.application.id);
          setApplicationId(res.data.application.id);
          setConfirmedApp(true);
          creditLoad();
        }
      });
  };

  const createOffer = (method, applicationId, type) => {
    axios
      .post(apiUrl, {
        method: method,
        appId: applicationId,
        offer: JSON.stringify(offer),
      })
      .then((res, err) => {
        if (err) {
          console.log(err);
        }
        // console.log(res.data.errors)
        // console.log(res.data)
        if (res.data.errors) {
          return (
            setShowError(true),
            setErrorMessage(`${res.data.errors[0].message}`),
            setTimeout(function () {
              setShowError(false);
              setErrorMessage(``);
            }, 10000),
            setSignLoading(false)
          );
        }
        if (res.data.id) {
          setMosaicOfferId(res.data.id);
          addMosaicOfferId(applicationId, res.data.id);
          shareOffer("shareOffer", res.data.id, type, applicationId);
          setTimeout(function () {
            getOfferInfo("getOffer", res.data.id);
          }, 10000);
        }
      });
  };

  const shareOffer = (method, offerId, type, applicationId) => {
    axios
      .post(apiUrl, {
        method: method,
        offId: offerId,
        shareType: JSON.stringify({
          method: type,
        }),
      })
      .then((res, err) => {
        if (err) {
          console.log(err);
        }
        // console.log(res.data.errors)
        // console.log(res.data)
        if (res.data.errors) {
          return (
            setShowError(true),
            setErrorMessage(`${res.data.errors[0].message}`),
            setTimeout(function () {
              setShowError(false);
              setErrorMessage(``);
            }, 10000)
          );
        }
        if (res.data.id) {
          addMosaicShareId(applicationId, res.data.id);
          setShareId(res.data.id);
        }
        if (res.data.id && type === "Link") {
          setTimeout(function () {
            getMosaicOfferLink("getLink", offerId, res.data.id);
          }, 5000);
        }
        if (res.data.id && type === "Email") {
          setConfirmEmail(true);
          setErrorMessage(`Loan Docs sent to ${email}`);
          setTimeout(function () {
            setConfirmEmail(false);
          }, 5000);
        }
      });
  };

  const getMosaicOfferLink = (method, offerId, shareId) => {
    axios
      .post(apiUrl, {
        method: method,
        offerId: offerId,
        shareId: shareId,
      })
      .then((res, err) => {
        if (err) {
          console.log(err);
          setSignLoading(false);
        }
        // console.log(res.data)
        setOfferLink(res.data.data.links[0].link);
        setSignLoading(false);
      });
  };

  const getOfferInfo = (method, offerId) => {
    axios
      .post(apiUrl, {
        method: method,
        offerId: offerId,
      })
      .then((res, err) => {
        if (err) {
          console.log(err);
          // setSignLoading(false)
        }
        console.log(res.data);
        if (res.data.projects[0].id) {
          setTimeout(function () {
            updateEquipment(
              "updateEquipment",
              equipmentInfo,
              res.data.projects[0].id
            );
            setMosaicProjId(res.data.projects[0].id);
          }, 20000);
          // console.log(equipmentInfo, res.data.id)
        }
      });
  };

  const updateEquipment = (method, equipment, projectId) => {
    axios
      .post(apiUrl, {
        method: method,
        equipment: JSON.stringify(equipment),
        projectId: projectId,
      })
      .then((res, err) => {
        if (err) {
          console.log(err);
        }
        // console.log(res.data.errors)
        // console.log(res.data)
      });
  };

  useEffect(() => {
    setSocial(social.replace(/\D/g, ""));
  }, [social]);

  useEffect(() => {
    getMosaicApp();
  }, []);

  const createApplication = () => {
    if (social.length !== 4) {
      return (
        setShowError(true),
        setErrorMessage(`Please add customer's social`),
        setTimeout(function () {
          setShowError(false);
          setErrorMessage(``);
        }, 10000)
      );
    }
    if (annualIncome === "") {
      return (
        setShowError(true),
        setErrorMessage(`Please add customer's annual income`),
        setTimeout(function () {
          setShowError(false);
          setErrorMessage(``);
        }, 10000)
      );
    }
    if (
      birthDay === "" ||
      birthMonth === "" ||
      birthYear === "" ||
      fullBirthDate === "Invalid date"
    ) {
      return (
        setShowError(true),
        setErrorMessage(`Please add customer's date of birth info`),
        setTimeout(function () {
          setShowError(false);
          setErrorMessage(``);
        }, 10000)
      );
    }
    if (coApply) {
      if (
        coBirthDay === "" ||
        coBirthMonth === "" ||
        coBirthYear === "" ||
        coFullBirthDate === "Invalid date"
      ) {
        return (
          setShowError(true),
          setErrorMessage(`Please add co-applicant's date of birth info`),
          setTimeout(function () {
            setShowError(false);
            setErrorMessage(``);
          }, 10000)
        );
      }
      if (coAnnualIncome === "") {
        return (
          setShowError(true),
          setErrorMessage(`Please add co-applicant's annual income`),
          setTimeout(function () {
            setShowError(false);
            setErrorMessage(``);
          }, 10000)
        );
      }
      if (coSocial.length !== 4) {
        return (
          setShowError(true),
          setErrorMessage(`Please add co-applicant's social`),
          setTimeout(function () {
            setShowError(false);
            setErrorMessage(``);
          }, 10000)
        );
      }
      if (coFirstName === "" || coLastName === "") {
        return (
          setShowError(true),
          setErrorMessage(`Please add co-applicant's name`),
          setTimeout(function () {
            setShowError(false);
            setErrorMessage(``);
          }, 10000)
        );
      }
      if (coPhoneNumber === "") {
        return (
          setShowError(true),
          setErrorMessage(`Please add co-applicant's phone number`),
          setTimeout(function () {
            setShowError(false);
            setErrorMessage(``);
          }, 10000)
        );
      }
      if (coEmailA === "") {
        return (
          setShowError(true),
          setErrorMessage(`Please add co-applicant's email`),
          setTimeout(function () {
            setShowError(false);
            setErrorMessage(``);
          }, 10000)
        );
      }
      if (coAddress) {
        if (coStreetA === "") {
          return (
            setShowError(true),
            setErrorMessage(`Please add co-applicant's street`),
            setTimeout(function () {
              setShowError(false);
              setErrorMessage(``);
            }, 10000)
          );
        }
        if (coCityA === "") {
          return (
            setShowError(true),
            setErrorMessage(`Please add co-applicant's city`),
            setTimeout(function () {
              setShowError(false);
              setErrorMessage(``);
            }, 10000)
          );
        }
        if (coStateA === "") {
          return (
            setShowError(true),
            setErrorMessage(`Please add co-applicant's state`),
            setTimeout(function () {
              setShowError(false);
              setErrorMessage(``);
            }, 10000)
          );
        }
        if (coZipA === "") {
          return (
            setShowError(true),
            setErrorMessage(`Please add co-applicant's zip`),
            setTimeout(function () {
              setShowError(false);
              setErrorMessage(``);
            }, 10000)
          );
        }
      }
    }
    return (
      mosaicApi("creditApp", version, application),
      // return mosaicApi('creditApp', application),
      setLoading(true)
    );
  };

  const mappedApplications = apps.map((app, i) => {
    return (
      <tr key={i}>
        <td className="qualyText bold" scope="row">
          {app.appFirstName} {app.appLastName}
          {app.appCoFirstName
            ? ` & ${app.appCoFirstName} ${app.appCoLastName}`
            : null}
        </td>
        <td className="qualyText bold" scope="row">
          {moment(app.time).format("MM/DD/YYYY h:mm A")}
        </td>
        <td
          className={
            app.shareId
              ? "qualyText bold docs"
              : app.decision === "Approved"
              ? "qualyText bold approved"
              : app.decision === "Declined" || app.decision === "Blocked"
              ? "qualyText bold declined"
              : app.decision === "ApprovedWithStipulations"
              ? "qualyText bold condition"
              : "qualyText bold"
          }
          scope="row"
        >
          {app.shareId
            ? "Docs Sent"
            : app.decision === "ApprovedWithStipulations"
            ? "Conditionally Approved"
            : app.decision}
        </td>
        <td
          className="qualyText blue"
          scope="row"
          onClick={() => {
            getMosaicAppInfo(app.appId);
            setConfirmedApp(true);
          }}
        >
          View
        </td>
      </tr>
    );
  });

  function formatPhoneNumber(value) {
    // if input value is falsy eg if the user deletes the input, then just return
    if (!value) return value;

    // clean the input for any non-digit values.
    const phoneNumber = value.replace(/[^\d]/g, "");

    // phoneNumberLength is used to know when to apply our formatting for the phone number
    const phoneNumberLength = phoneNumber.length;

    // we need to return the value with no formatting if its less then four digits
    // this is to avoid weird behavior that occurs if you  format the area code to early
    if (phoneNumberLength < 4) return phoneNumber;

    // if phoneNumberLength is greater than 4 and less the 7 we start to return
    // the formatted number
    if (phoneNumberLength < 7) {
      return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(3)}`;
    }

    // finally, if the phoneNumberLength is greater then seven, we add the last
    // bit of formatting and return it.
    return `(${phoneNumber.slice(0, 3)}) ${phoneNumber.slice(
      3,
      6
    )}-${phoneNumber.slice(6, 10)}`;
  }

  const handleInput = (e, operation) => {
    // this is where we'll call the phoneNumberFormatter function
    const formattedPhoneNumber = formatPhoneNumber(e.target.value);
    operation(formattedPhoneNumber);
  };

  const handleNumChange = (e, operation) => {
    const limit = 4;
    operation(e.target.value.slice(0, limit));
  };

  return (
    <>
      <div className="container">
        <div className="custContainer">
          <div className="row justify-content-between">
            <div className="col">
              <img className="img logo" src={MosaicLogo}></img>
            </div>
            <div className="col" align="end">
              <div className="qualyText header back">
                <Button
                  variant="outlined"
                  color="default"
                  onClick={() => {
                    setQualify(false);
                    setViewApps(false);
                    setAgree(false);
                  }}
                >
                  Back
                </Button>
              </div>
            </div>
          </div>
          {confirmedApp ? (
            <>
              <div className="row">
                <div className="col">
                  <div className="qualyText header">Credit Application</div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="qualyText">
                    Please view your application details and status below.
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="qualyText info">First Name</div>
                  <div className="qualyText info bold moz">{firstName}</div>
                </div>
                <div className="col">
                  <div className="qualyText info">Last Name</div>
                  <div className="qualyText info bold moz">{lastName}</div>
                </div>
                <div className="col">
                  <div className="qualyText info">Email Address</div>
                  <div className="qualyText info bold moz">{emailA}</div>
                </div>
                <div className="col">
                  <div className="qualyText info">Mobile Phone</div>
                  <div className="qualyText info bold moz">
                    {phoneNumber.replace(/(\d{3})(\d{3})(\d{4})/, "($1) $2-$3")}
                  </div>
                </div>
              </div>
              {coFirstName ? (
                <>
                  <div className="row">
                    <div className="col">
                      <div className="qualyText info moz">
                        Co-Applicant First Name
                      </div>
                      <div className="qualyText info bold">{coFirstName}</div>
                    </div>
                    <div className="col">
                      <div className="qualyText info moz">
                        Co-Applicant Last Name
                      </div>
                      <div className="qualyText info bold">{coLastName}</div>
                    </div>
                    <div className="col">
                      <div className="qualyText info moz">
                        Co-Applicant Email Address
                      </div>
                      <div className="qualyText info bold">{coEmailA}</div>
                    </div>
                    <div className="col">
                      <div className="qualyText info moz">
                        Co-Applicant Mobile Phone
                      </div>
                      <div className="qualyText info bold">
                        {coPhoneNumber.replace(
                          /(\d{3})(\d{3})(\d{4})/,
                          "($1) $2-$3"
                        )}
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
              {shareId ? (
                <></>
              ) : (
                <>
                  {creditResult === "Approved" ||
                  creditMessage.status === "ApprovedWithStipulations" ? (
                    <>
                      <div className="row">
                        <div className="col-3">
                          <div className="qualyText holders l">
                            Qualified Loans
                          </div>
                          <select
                            className="custInput credit"
                            onChange={(e) =>
                              setFinanceProductId(e.target.value)
                            }
                          >
                            <option style={{ display: "none" }}>
                              Select Loan
                            </option>
                            {mappedApprovedLoans}
                          </select>
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              )}
              {showError || confirmEmail ? (
                <>
                  <div className="row justify-content-center">
                    <div className="col" align="center">
                      <div
                        className={
                          confirmEmail ? "errorMessage green" : "errorMessage"
                        }
                      >
                        {errorMessage}
                      </div>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
              <div className="row">
                <div className="col">
                  {creditResult === "Pending" ? (
                    ""
                  ) : (
                    <div className="qualyText credit">Credit Decision</div>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col">
                  {creditResult === "Pending" ? (
                    <></>
                  ) : (
                    <button
                      className={
                        creditResult === "Approved"
                          ? "custButton approved"
                          : creditMessage.status === "ApprovedWithStipulations"
                          ? "custButton condition"
                          : creditResult === "Declined" ||
                            creditMessage.status === "Blocked"
                          ? "custButton declined"
                          : "qualyText"
                      }
                    >
                      {creditMessage.status === "ApprovedWithStipulations"
                        ? "Conditionally Approved"
                        : creditMessage.status === "Blocked"
                        ? "Blocked"
                        : creditResult}
                    </button>
                  )}
                </div>
                {creditResult === "Declined" ||
                creditMessage.status === "Blocked" ? (
                  <>
                    <div className="col">
                      <button
                        className="custButton confirm credit"
                        onClick={() => {
                          setViewApps(false);
                          setOwnHome(false);
                          setAgree(false);
                          setConfirmedApp(false);
                          setCreditMessage({});
                          setCreditResult("Pending");
                        }}
                      >
                        {" "}
                        Create New Application
                      </button>
                    </div>
                  </>
                ) : creditResult === "Pending" ? (
                  <></>
                ) : (
                  <>
                    {shareId ? (
                      <>
                        {offerLink ? (
                          <>
                            <div className="col-3">
                              <a href={offerLink} target="_blank">
                                <button className="custButton confirm credit">
                                  {" "}
                                  {signLoading ? (
                                    <CircularProgress
                                      size={40}
                                      color="inherit"
                                    />
                                  ) : (
                                    "Sign Loan Docs"
                                  )}
                                </button>
                              </a>
                            </div>
                          </>
                        ) : (
                          <>
                            <div className="col-3">
                              <button
                                className="custButton confirm credit"
                                onClick={() => {
                                  shareOffer(
                                    "shareOffer",
                                    offerId,
                                    "Link",
                                    applicationId
                                  );
                                  setSignLoading(true);
                                }}
                              >
                                {" "}
                                {signLoading ? (
                                  <CircularProgress size={40} color="inherit" />
                                ) : (
                                  "Create Loan Docs"
                                )}
                              </button>
                            </div>
                          </>
                        )}
                        <div className="col-3">
                          <button
                            className="custButton cancel credit"
                            onClick={() =>
                              shareOffer(
                                "shareOffer",
                                offerId,
                                "Email",
                                applicationId
                              )
                            }
                          >
                            Email Loan Docs
                          </button>
                        </div>
                      </>
                    ) : (
                      <>
                        <div className="col-3">
                          <button
                            className="custButton confirm credit"
                            onClick={() => {
                              createOffer("createOffer", applicationId, "Link");
                              setSignLoading(true);
                            }}
                          >
                            {signLoading ? (
                              <CircularProgress size={40} color="inherit" />
                            ) : (
                              "Create Loan Docs"
                            )}
                          </button>
                        </div>
                        <div className="col-3">
                          <button
                            className="custButton cancel credit"
                            onClick={() =>
                              createOffer("createOffer", applicationId, "Email")
                            }
                          >
                            Email Loan Docs
                          </button>
                        </div>
                      </>
                    )}
                  </>
                )}
              </div>
              {creditMessage.status === "ApprovedWithStipulations" ? (
                <>
                  <div className="row">
                    <div className="savingsText modals fin">
                      Credit Decision:{" "}
                    </div>
                  </div>
                  <div className="row">
                    <div className="qualyText decisions">{creditResult}</div>
                  </div>
                </>
              ) : creditMessage.status === "Blocked" ? (
                <>
                  <div className="row">
                    <div className="savingsText modals fin">
                      Credit Decision:{" "}
                    </div>
                  </div>
                  <div className="row">
                    <div className="qualyText decisions">{creditResult}</div>
                  </div>
                </>
              ) : (
                <></>
              )}
              <div>
                <div>
                  {creditResult === "Approved" ||
                  creditMessage.status === "ApprovedWithStipulations" ? (
                    <>
                      <div className="row">
                        <div className="savingsText modals fin">
                          Loan Amount:{" "}
                        </div>
                      </div>
                      <div className="row">
                        <div className="qualyText decisions">
                          {creditMessage.applicantMessages.actualLoanAmount}
                        </div>
                      </div>
                      <div className="row">
                        <div className="savingsText modals fin">
                          Borrowing Amount:{" "}
                        </div>
                      </div>
                      <div className="row">
                        <div className="qualyText decisions">
                          {creditMessage.applicantMessages.borrowingLimit}
                        </div>
                      </div>
                      <div className="row">
                        <div className="savingsText modals fin">
                          Application Expiration:{" "}
                        </div>
                      </div>
                      <div className="row">
                        <div className="qualyText decisions">
                          {creditMessage.applicantMessages.expiration}
                        </div>
                      </div>
                    </>
                  ) : creditResult === "Declined" ? (
                    <>
                      <div className="row">
                        <div className="savingsText modals fin">
                          Credit Info:{" "}
                        </div>
                      </div>
                      <div className="row">
                        <div className="qualyText decisions">
                          {creditMessage.applicantMessages.notApproved}
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </div>
              </div>
              <div className="row">
                <div className="col-6">
                  {creditResult === "Pending" ? (
                    <button
                      className="custButton confirm credit"
                      disabled={loading}
                      variant="outlined"
                      onClick={() => mosaicApiGetApp("getApp", applicationId)}
                    >
                      {loading ? (
                        <CircularProgress size={40} color="inherit" />
                      ) : (
                        "Get Credit Result"
                      )}
                    </button>
                  ) : (
                    ""
                  )}
                </div>
              </div>
            </>
          ) : viewApps ? (
            <>
              <div className="row">
                <h3 className="menuFont qualy">Applications</h3>
              </div>
              <table className="table table-striped table-borderless">
                <thead>
                  <tr className="table-borderless">
                    <th className="qualyText" scope="col">
                      Applicant Name
                    </th>
                    <th className="qualyText" scope="col">
                      Submitted
                    </th>
                    <th className="qualyText" scope="col">
                      Status
                    </th>
                    <th className="qualyText" scope="col"></th>
                  </tr>
                </thead>
                <tbody>{mappedApplications}</tbody>
              </table>
              <div className="row">
                <div className="col-5">
                  <button
                    className="custButton confirm"
                    onClick={() => setViewApps(false)}
                  >
                    Create New Application
                  </button>
                </div>
              </div>
            </>
          ) : (
            <>
              <div className="row">
                <div className="col">
                  <div className="qualyText header">Pre-qualification</div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="qualyText">
                    Please provide a valid email address you can access and a
                    mobile phone number to receive instant notifications about
                    your project and keep it running smoothly.
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm">
                  <div className="qualyText holders">First Name</div>
                  <input
                    className="custInput qualy"
                    placeholder="Legal First Name"
                    value={firstName}
                    onChange={(e) => setFirstName(e.target.value)}
                  ></input>
                </div>
                <div className="col">
                  <div>
                    <div className="qualyText holders">Last Name</div>
                  </div>
                  <input
                    className="custInput qualy"
                    placeholder="Legal Last Name"
                    value={lastName}
                    onChange={(e) => setLastName(e.target.value)}
                  ></input>
                </div>
              </div>
              <div className="row">
                <div className="col-sm">
                  <div>
                    <div className="qualyText holders">Email Address</div>
                  </div>
                  <input
                    className="custInput qualy"
                    placeholder="email@email.com"
                    value={emailA}
                    onChange={(e) => setEmailA(e.target.value)}
                  ></input>
                </div>
                <div className="col">
                  <div>
                    <div className="qualyText holders">Mobile Phone</div>
                  </div>
                  <input
                    className="custInput qualy"
                    type="tel"
                    placeholder="(000) 000-0000"
                    value={phoneNumber}
                    onChange={(e) => handleInput(e, setPhoneNumber)}
                  ></input>
                </div>
              </div>
              <div className="row">
                <div className="col-sm">
                  <div>
                    <div className="qualyText holders">
                      Personal Income (Annual)
                    </div>
                  </div>
                  <NumberFormat
                    className="custInput qualy"
                    thousandSeparator={true}
                    prefix="$"
                    placeholder="$XX,XXX"
                    type="text"
                    onChange={(e) => setAnnualIncome(e.target.value)}
                  ></NumberFormat>
                  {viewIncome ? (
                    <div className="qualyText disc">
                      {income}{" "}
                      <span onClick={() => setViewIncome(!viewIncome)}>
                        minimize
                      </span>
                    </div>
                  ) : (
                    <div className="qualyText disc">
                      {ecoa}{" "}
                      <span onClick={() => setViewIncome(!viewIncome)}>
                        read more
                      </span>
                    </div>
                  )}
                </div>
                <div className="col">
                  <div className="qualyText holders">
                    Other Household Income
                  </div>
                  <NumberFormat
                    className="custInput qualy"
                    thousandSeparator={true}
                    prefix="$"
                    placeholder="$XX,XXX"
                    type="text"
                    onChange={(e) => setSecondaryIncome(e.target.value)}
                  ></NumberFormat>
                  <div className="qualyText disc">{otherInc}</div>
                </div>
                <div className="col">
                  <div>
                    <div className="qualyText holders">
                      Last 4 of Social Security
                    </div>
                  </div>
                  <input
                    className="custInput qualy"
                    placeholder="0000"
                    type="number"
                    maxLength={4}
                    value={social}
                    onChange={(e) => handleNumChange(e, setSocial)}
                  ></input>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div>
                    <div className="qualyText holders">Birthday Month</div>
                  </div>
                  <select
                    className="custInput qualy"
                    onChange={(e) => setBirthMonth(e.target.value)}
                  >
                    <option style={{ display: "none" }}>Month</option>
                    {mappedMonths}
                  </select>
                </div>
                <div className="col">
                  <div>
                    <div className="qualyText holders">Birthday Day</div>
                  </div>
                  <select
                    className="custInput qualy"
                    onChange={(e) => setBirthDay(e.target.value)}
                  >
                    <option style={{ display: "none" }}>Day</option>
                    {mappedDays}
                  </select>
                </div>
                <div className="col">
                  <div>
                    <div className="qualyText holders">Birthday Year</div>
                  </div>
                  <select
                    className="custInput qualy"
                    onChange={(e) => setBirthYear(e.target.value)}
                  >
                    <option style={{ display: "none" }}>Year</option>
                    {mappedYears}
                  </select>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="qualyText">
                    Tell us where this project will be located.
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col-sm-4">
                  <div>
                    <div className="qualyText holders">Street Address</div>
                  </div>
                  <input
                    className="custInput qualy"
                    placeholder="Street"
                    value={streetA}
                    onChange={(e) => setStreetA(e.target.value)}
                  ></input>
                </div>
                <div className="col-sm-4">
                  <div>
                    <div className="qualyText holders">City</div>
                  </div>
                  <input
                    className="custInput qualy"
                    placeholder="City"
                    value={cityA}
                    onChange={(e) => setCityA(e.target.value)}
                  ></input>
                </div>
                <div className="col-sm-2 col">
                  <div>
                    <div className="qualyText holders">State</div>
                    <select
                      className="custInput qualy moz"
                      onChange={(e) => setStateA(e.target.value)}
                    >
                      <option style={{ display: "none" }}> {stateA}</option>
                      {mappedStates}
                    </select>
                  </div>
                </div>
                <div className="col-sm-2 col">
                  <div>
                    <div className="qualyText holders">Zip Code</div>
                  </div>
                  <input
                    className="custInput qualy"
                    placeholder="00000"
                    label={zip}
                    value={zipA}
                    onChange={(e) => setZipA(e.target.value)}
                  ></input>
                </div>
              </div>
              <div
                className="row"
                onClick={(e) => {
                  setOwnHome(!ownHome);
                }}
              >
                <div className="col-sm-1 col-2">
                  <div className={ownHome ? "checkBox checked" : "checkBox"}>
                    <img src={checkmark}></img>
                  </div>
                </div>
                <div className="col">
                  <div className="qualyText check">{own}</div>
                </div>
              </div>
              <div
                className="row"
                onClick={(e) => {
                  setResident(!resident);
                }}
              >
                <div className="col-sm-1 col-2">
                  <div className={resident ? "checkBox checked" : "checkBox"}>
                    <img src={checkmark}></img>
                  </div>
                </div>
                <div className="col-sm-1 col-2">
                  <div className="qualyText check">Yes</div>
                </div>
                <div className="col-sm-1 col-2">
                  <div className={!resident ? "checkBox checked" : "checkBox"}>
                    <img src={checkmark}></img>
                  </div>
                </div>
                <div className="col-sm-1 col-2">
                  <div className="qualyText check">No</div>
                </div>
                <div className="col">
                  <div className="qualyText check">{res}</div>
                </div>
              </div>
              <div
                className="row"
                onClick={(e) => {
                  setCoApply(!coApply);
                }}
              >
                <div className="col-sm-1 col-2">
                  <div className={coApply ? "checkBox checked" : "checkBox"}>
                    <img src={checkmark}></img>
                  </div>
                </div>
                <div className="col">
                  <div className="qualyText check">Add Co-Applicant</div>
                </div>
              </div>

              {coApply ? (
                <>
                  <div className="row">
                    <div className="col-sm">
                      <div className="qualyText holders">
                        Co-Applicant First Name
                      </div>
                      <input
                        className="custInput qualy"
                        placeholder="Legal First Name"
                        value={coFirstName}
                        onChange={(e) => setCoFirstName(e.target.value)}
                      ></input>
                    </div>
                    <div className="col">
                      <div>
                        <div className="qualyText holders">
                          Co-Applicant Last Name
                        </div>
                      </div>
                      <input
                        className="custInput qualy"
                        placeholder="Legal Last Name"
                        value={coLastName}
                        onChange={(e) => setCoLastName(e.target.value)}
                      ></input>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm">
                      <div>
                        <div className="qualyText holders">
                          Co-Applicant Email Address
                        </div>
                      </div>
                      <input
                        className="custInput qualy"
                        placeholder="email@email.com"
                        value={coEmailA}
                        onChange={(e) => setCoEmailA(e.target.value)}
                      ></input>
                    </div>
                    <div className="col">
                      <div>
                        <div className="qualyText holders">
                          Co-Applicant Mobile Phone
                        </div>
                      </div>
                      <input
                        className="custInput qualy"
                        type="tel"
                        placeholder="(000) 000-0000"
                        value={coPhoneNumber}
                        onChange={(e) => handleInput(e, setCoPhoneNumber)}
                      ></input>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col-sm">
                      <div>
                        <div className="qualyText holders">
                          Co-Applicant Personal Income (Annual)
                        </div>
                      </div>
                      <NumberFormat
                        className="custInput qualy"
                        thousandSeparator={true}
                        prefix="$"
                        placeholder="$XX,XXX"
                        type="text"
                        onChange={(e) => setCoAnnualIncome(e.target.value)}
                      ></NumberFormat>
                      {viewIncome ? (
                        <div className="qualyText disc">
                          {income}{" "}
                          <span onClick={() => setViewIncome(!viewIncome)}>
                            minimize
                          </span>
                        </div>
                      ) : (
                        <div className="qualyText disc">
                          {ecoa}{" "}
                          <span onClick={() => setViewIncome(!viewIncome)}>
                            read more
                          </span>
                        </div>
                      )}
                    </div>
                    <div className="col">
                      <div>
                        <div className="qualyText holders">
                          Last 4 of Co-Applicant's Social Security
                        </div>
                      </div>
                      <input
                        className="custInput qualy"
                        placeholder="0000"
                        type="number"
                        maxLength={4}
                        value={coSocial}
                        onChange={(e) => handleNumChange(e, setCoSocial)}
                      ></input>
                    </div>
                  </div>
                  <div className="row">
                    <div className="col">
                      <div>
                        <div className="qualyText holders">
                          Co-Applicant Birthday Month
                        </div>
                      </div>
                      <select
                        className="custInput qualy moz"
                        onChange={(e) => setCoBirthMonth(e.target.value)}
                      >
                        <option style={{ display: "none" }}>Month</option>
                        {mappedMonths}
                      </select>
                    </div>
                    <div className="col">
                      <div>
                        <div className="qualyText holders">
                          Co-Applicant Birthday Day
                        </div>
                      </div>
                      <select
                        className="custInput qualy"
                        onChange={(e) => setCoBirthDay(e.target.value)}
                      >
                        <option style={{ display: "none" }}>Day</option>
                        {mappedCoDays}
                      </select>
                    </div>
                    <div className="col">
                      <div>
                        <div className="qualyText holders">
                          Co-Applicant Birthday Year
                        </div>
                      </div>
                      <select
                        className="custInput qualy"
                        onChange={(e) => setCoBirthYear(e.target.value)}
                      >
                        <option style={{ display: "none" }}>Year</option>
                        {mappedYears}
                      </select>
                    </div>
                  </div>
                  <div
                    className="row"
                    onClick={(e) => {
                      setCoOwnHome(!coOwnHome);
                    }}
                  >
                    <div className="col-sm-1 col-2">
                      <div
                        className={coOwnHome ? "checkBox checked" : "checkBox"}
                      >
                        <img src={checkmark}></img>
                      </div>
                    </div>
                    <div className="col">
                      <div className="qualyText check">{own}</div>
                    </div>
                  </div>
                  <div
                    className="row"
                    onClick={(e) => {
                      setCoResident(!coResident);
                    }}
                  >
                    <div className="col-sm-1 col-2">
                      <div
                        className={coResident ? "checkBox checked" : "checkBox"}
                      >
                        <img src={checkmark}></img>
                      </div>
                    </div>
                    <div className="col-sm-1 col-2">
                      <div className="qualyText check">Yes</div>
                    </div>
                    <div className="col-sm-1 col-2">
                      <div
                        className={
                          !coResident ? "checkBox checked" : "checkBox"
                        }
                      >
                        <img src={checkmark}></img>
                      </div>
                    </div>
                    <div className="col-sm-1 col-2">
                      <div className="qualyText check">No</div>
                    </div>
                    <div className="col">
                      <div className="qualyText check">{res}</div>
                    </div>
                  </div>
                  <div
                    className="row"
                    onClick={(e) => {
                      setCoAddress(!coAddress);
                    }}
                  >
                    <div className="col-sm-1 col-2">
                      <div
                        className={coAddress ? "checkBox checked" : "checkBox"}
                      >
                        <img src={checkmark}></img>
                      </div>
                    </div>
                    <div className="col">
                      <div className="qualyText check">
                        Co-Applicant Mailing Address different from {firstName}{" "}
                        {lastName}'s?
                      </div>
                    </div>
                  </div>
                  {coAddress ? (
                    <>
                      <div className="row">
                        <div className="col-sm-4">
                          <div>
                            <div className="qualyText holders">
                              Co-Applicant Street Address
                            </div>
                          </div>
                          <input
                            className="custInput qualy"
                            placeholder="Street"
                            value={coStreetA}
                            onChange={(e) => setCoStreetA(e.target.value)}
                          ></input>
                        </div>
                        <div className="col-sm-4">
                          <div>
                            <div className="qualyText holders">
                              Co-Applicant City
                            </div>
                          </div>
                          <input
                            className="custInput qualy"
                            placeholder="City"
                            value={coCityA}
                            onChange={(e) => setCoCityA(e.target.value)}
                          ></input>
                        </div>
                        <div className="col-sm-2 col">
                          <div>
                            <div className="qualyText holders">
                              Co-App State
                            </div>
                            <select
                              className="custInput qualy"
                              onChange={(e) => setCoStateA(e.target.value)}
                            >
                              <option style={{ display: "none" }}>
                                {" "}
                                {coStateA}
                              </option>
                              {mappedStates}
                            </select>
                          </div>
                        </div>
                        <div className="col-sm-2 col">
                          <div>
                            <div className="qualyText holders">
                              Co-App Zip Code
                            </div>
                          </div>
                          <input
                            className="custInput qualy"
                            placeholder="00000"
                            label={zip}
                            value={coZipA}
                            onChange={(e) => setCoZipA(e.target.value)}
                          ></input>
                        </div>
                      </div>
                    </>
                  ) : (
                    <></>
                  )}
                </>
              ) : (
                <>
                  <div className="row">
                    <div className="col">
                      <div className="qualyText disco">{coApp}</div>
                    </div>
                  </div>
                </>
              )}
              <div className="row">
                <div className="col">
                  <div className="qualyText">
                    For information about our collection, sharing, and use of
                    your personal information, please see our{" "}
                    <a href="https://joinmosaic.com/privacy/" target="blank">
                      {" "}
                      <span>privacy policy.</span>
                    </a>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="qualyText">{trueLender}</div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="qualyText">
                    <img src={ehl1}></img>
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="qualyText header pat">
                    PATRIOT ACT DISCLOSURE
                  </div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <div className="qualyText pad">{pad.slice(23)}</div>
                </div>
              </div>
              <div className="row">
                <div className="col">
                  <ul>
                    {viewGd ? (
                      <>
                        <div>
                          <div
                            className="qualyText"
                            onClick={() => setViewGd(!viewGd)}
                          >
                            {gd}
                          </div>
                        </div>
                        <div>
                          <div onClick={() => setViewGd(!viewGd)}>Close</div>
                        </div>
                      </>
                    ) : (
                      <li>
                        <div
                          className="qualyText discos"
                          onClick={() => setViewGd(!viewGd)}
                        >
                          General Disclosures
                        </div>
                      </li>
                    )}
                    {viewCpa2 ? (
                      <>
                        <div>
                          <div
                            className="qualyText"
                            onClick={() => setViewCpa2(!viewCpa2)}
                          >
                            {cpa2}
                          </div>
                        </div>
                        <div>
                          <div onClick={() => setViewCpa2(!viewCpa2)}>
                            Close
                          </div>
                        </div>
                      </>
                    ) : (
                      <li>
                        <div
                          className="qualyText discos"
                          onClick={() => setViewCpa2(!viewCpa2)}
                        >
                          Authorization to Obtain Your Consumer Reports and
                          Share Information
                        </div>
                      </li>
                    )}
                    {viewEsign ? (
                      <>
                        <div>
                          <div
                            className="qualyText"
                            onClick={() => setViewEsign(!viewEsign)}
                          >
                            {esign}
                          </div>
                        </div>
                        <div>
                          <div onClick={() => setViewEsign(!viewEsign)}>
                            Close
                          </div>
                        </div>
                      </>
                    ) : (
                      <li>
                        <div
                          className="qualyText discos"
                          onClick={() => setViewEsign(!viewEsign)}
                        >
                          Electronic Communications Consent
                        </div>
                      </li>
                    )}
                    {viewTcpa ? (
                      <>
                        <div>
                          <div
                            className="qualyText"
                            onClick={() => setViewTcpa(!viewTcpa)}
                          >
                            {tcpa}
                          </div>
                        </div>
                        <div>
                          <div onClick={() => setViewTcpa(!viewTcpa)}>
                            Close
                          </div>
                        </div>
                      </>
                    ) : (
                      <li>
                        <div
                          className="qualyText discos"
                          onClick={() => setViewTcpa(!viewTcpa)}
                        >
                          Automated Calling/Text Messaging and Call Recording
                          Consent
                        </div>
                      </li>
                    )}
                    {viewArb ? (
                      <>
                        <div>
                          <div
                            className="qualyText"
                            onClick={() => setViewArb(!viewArb)}
                          >
                            {arb}
                          </div>
                        </div>
                        <div>
                          <div onClick={() => setViewArb(!viewArb)}>Close</div>
                        </div>
                      </>
                    ) : (
                      <li>
                        <div
                          className="qualyText discos"
                          onClick={() => setViewArb(!viewArb)}
                        >
                          An Arbitration Provision
                        </div>
                      </li>
                    )}
                    {viewStateDisc ? (
                      <>
                        <div>
                          <div
                            className="qualyText"
                            onClick={() => setViewStateDisc(!viewStateDisc)}
                          >
                            {stateDisc}
                          </div>
                        </div>
                        <div>
                          <div onClick={() => setViewStateDisc(!viewStateDisc)}>
                            Close
                          </div>
                        </div>
                      </>
                    ) : (
                      <li>
                        <div
                          className="qualyText discos"
                          onClick={() => setViewStateDisc(!viewStateDisc)}
                        >
                          State Disclosure Notices
                        </div>
                      </li>
                    )}
                  </ul>
                </div>
              </div>
              <div
                className="row"
                onClick={(e) => {
                  setAgree(!agree);
                }}
              >
                <div className="col-sm-1 col-2">
                  <div className={agree ? "checkBox checked" : "checkBox"}>
                    <img src={checkmark}></img>
                  </div>
                </div>
                <div className="col">
                  <div className="qualyText check">
                    I Agree to the Terms and Conditions above.
                  </div>
                </div>
              </div>
              {showError ? (
                <>
                  <div className="row justify-content-center">
                    <div className="col" align="center">
                      <div className="errorMessage">{errorMessage}</div>
                    </div>
                  </div>
                </>
              ) : (
                <></>
              )}
              <div className="row justify-content-center">
                <div className="col-4">
                  <button
                    className={
                      (ownHome === true || coOwnHome === true) && agree === true
                        ? "qualyButton confirm"
                        : "qualyButton disabled"
                    }
                    disabled={
                      (ownHome === true || coOwnHome === true) && agree === true
                        ? false
                        : true
                    }
                    onClick={
                      loading
                        ? () => null
                        : () => {
                            createApplication();
                          }
                    }
                  >
                    {loading ? (
                      <CircularProgress size={40} color="inherit" />
                    ) : (
                      "Submit"
                    )}
                  </button>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-8">
                  <div className="qualyText bottom">
                    Submitting this pre-qualification will{" "}
                    <span>not affect</span> your credit score.
                  </div>
                </div>
              </div>
              <div className="row justify-content-center">
                <div className="col-8">
                  <div className="qualyText bottom bold">
                    YOUR INFORMATION IS SECURED BY{" "}
                    <img className="img" src={ssl}></img> SSL{" "}
                    <img className="img" src={encryption}></img> 128-BIT
                    ENCRYPTION
                  </div>
                </div>
              </div>
            </>
          )}
        </div>
      </div>
    </>
  );
};

export default MosaicQualify;
